import Vue from "vue";

function initialLoad() {
  return {
    CallTrackingSettings: {}
  };
}

const state = initialLoad();

const actions = {
  async loadCallTrackingSettings(context, platform) {
    let response = await context.getters.CxmApiClient.ProcessRequest(
      "get",
      "dashboard/get_dealer_settings_admin?accountPlatformId=" + platform
    );
    return response && response.data ? response.data : null;
  },
  async saveCallTrackingSettingsForPlatform(context, request) {
    let response = await context.getters.CxmApiClient.ProcessRequest(
      "post",
      "dashboard/save_dealer_settings_admin",
      request
    );
    return response && response.data ? response.data : null;
  },
  async fetchActiveCallTrackingSettingByAccount(context, request) {
    let response = await context.getters.CxmApiClient.ProcessRequest(
      "GET",
      `/api/calltracking/get_dealer_settings_by_account?accountId=${request.accountId}&onlyDealersWithCallTrackingFeature=${request.onlyDealersWithCallTrackingFeature}`
    );
    return response && response.data ? response.data : null;
  }
};

const mutations = {};

const getters = {};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/CallTracking.js